import { render, staticRenderFns } from "./ImportConfigBlock.vue?vue&type=template&id=1ef19ece&scoped=true&"
import script from "./ImportConfigBlock.vue?vue&type=script&lang=js&"
export * from "./ImportConfigBlock.vue?vue&type=script&lang=js&"
import style1 from "./ImportConfigBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef19ece",
  null
  
)

export default component.exports